import { render, staticRenderFns } from "./BlockTabs.vue?vue&type=template&id=15b4a7a6"
import script from "./BlockTabs.vue?vue&type=script&lang=js"
export * from "./BlockTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports